import React from 'react';
import PropTypes from 'prop-types';
import {
    Button, Collapse, Drawer, FormControl, IconButton, Input, InputLabel, List, ListItem, ListItemIcon,
    ListItemSecondaryAction, ListItemText, MenuItem, Popover, Select, Switch, TextField
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import IntegrationAutosuggest from './elements/IntegrationAutosuggest';
import {DatePicker} from 'material-ui-pickers';
import {
    AddCircle, CloudUpload, ColorLens, DateRange, Event, ExpandLess, ExpandMore, Group, KeyboardArrowLeft,
    KeyboardArrowRight, LockOpen, ModeEdit, Print, RemoveCircle, Settings
} from "@material-ui/icons"
import Password from "./elements/Password";
import Helper from "../Utils";
import C from "../Constants";
import ColorPicker from "./elements/ColorPicker";
import Utils from "./../Utils";
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import MultipleSelect from "./elements/MultipleSelect";

const styles = theme => ({
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    },
    updateGroupButton: {
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
    },
    drawerEntries: {
        minWidth: theme.spacing.unit * 40,
        width: "100%",
        height: "100%",
    },
    drawer: {
        //overflow: "hidden",
    },
    print: {},
});

class OptionsDrawer extends React.Component {

    state = {
        groupName: "",
        print: {to: moment().add(7, 'day').startOf('day').toDate(),
            from: moment().startOf('day').toDate()},
        hourTypeEditOpen: false,
        adminLoginOpen: false,
        hourTypesOpen: false,
        groupEditOpen: false,
        adminLoginName: this.props.groupData.groupName,
        groupContactData: C.CONTACT_DATA_NONE,
        groupHourTypes: [],
        groupAllowedHourTypes: [],
    };

    componentDidUpdate() {
        if (!this.isSuperAdmin() && this.isAdmin() && this.state.groupName != this.props.groupData.groupName) {
            this.groupEditNameChanged(this.props.groupData.groupName);
        }
    }

    render() {
        const {classes} = this.props;
        return <Drawer open={this.props.open} onClose={this.toggleDrawer} className={classes.drawer}>
            <List className={classes.drawerEntries}>
                <Scrollbars>
                    <ListItem><ListItemText primary={this.props.title}/></ListItem>
                    {this.renderUserLogout()}
                    {this.renderContact()}
                    {this.renderHourTypes()}
                    {this.renderPrint()}
                    {this.renderAdminLoginLogout()}
                    {this.renderGroupEdit()}
                    {this.renderSuperAdminEdit()}
                </Scrollbars>
            </List>
        </Drawer>;
    }

    openAdminLogin = () => this.setState({adminLoginOpen: !this.state.adminLoginOpen});
    changeValue = key => value => this.setState({[key]: value});
    changeValueByEvent = key => event => this.setState({[key]: event.target.value});
    toggleValue = key => () => this.setState({[key]: !this.state[key]});
    isAdmin = () => this.props.loginData != null && this.props.loginData.isGroupAdmin;
    isSuperAdmin = () => this.props.loginData != null && this.props.loginData.isSuperAdmin;
    toggleDrawer = () => this.props.app.toggleOptionsDrawer();
    loginAdmin = () => this.props.app.serverCommunication.serverLoginGroupOrAdmin(this.state.adminLoginName, this.state.adminLoginPassword, (failed) => this.setState({adminLoginFailed: failed}));
    logoutAdmin = () => this.props.app.serverCommunication.serverLogoutFromServer();
    changeValueFixed = (key, value) => () => this.setState({[key]: value});
    deleteGroup = () => this.props.app.serverCommunication.serverDeleteGroup(this.state.groupName);
    changeColorDialog = (hourTypeIndex, color) => (event) => this.setState({
        hourTypeEditAnchor: event.target,
        hourTypeEditOpen: true,
        hourTypeEditColor: color,
        hourTypeIndex: hourTypeIndex
    });
    changeColorDialogPrint = (hourTypeIndex, color) => (event) => this.setState({
        printHourTypeEditAnchor: event.target,
        printHourTypeEditOpen: true,
        printHourTypeEditColor: color,
        printHourTypeIndex: hourTypeIndex
    });
    handlePrintChangedFixed = (key, value) => () => {
        this.state.print[key] = value;
        this.props.app.setState({print: this.state.print});
    };
    handlePrintChanged = key => value => {
        this.handlePrintChangedFixed(key, value)();
    };
    changeColor = (color) => {
        const hourTypes = JSON.parse(JSON.stringify(this.props.groupData.hourTypes));
        hourTypes.find((hourType) => {
            return hourType.hourType === this.state.hourTypeIndex
        }, this)
            .color = color;
        this.props.app.serverCommunication.serverUpdateGroup(this.props.groupData.groupName, 'hourTypes', JSON.stringify(hourTypes));
    };
    logoutUser = () => {
        Helper.setHourPanelViewActive(false);
        if (!this.isAdmin()) this.props.app.serverCommunication.serverLogoutFromServer();
    };
    addGroup = () => {
        this.props.app.serverCommunication.serverInsertGroup(
            this.state.groupName, this.state.groupLoginPassword, this.state.groupAdminPassword, this.state.groupEmail,
            this.state.groupContactData, this.state.groupHourTypes, this.state.groupAllowedHourTypes,
            this.state.groupYoutubeLink, this.state.groupLocation);
    };
    editSuperAdmin = () => {
        this.props.app.serverCommunication.serverUpdateSuperAdmin(this.state.superAdminEditName, this.state.superAdminPassword);
        //after three seconds update the data!
        setTimeout(this.props.app.serverCommunication.serverQueryAllSuperAdmins, 3000);
    };
    groupEditNameChanged = (newGroupName) => {
        const that = this;
        this.props.app.serverCommunication.serverQueryGroupData(newGroupName, (data) => {
            if (data != null && data.groupName != null && data.groupName != "") {
                that.setState({
                    groupName: data.groupName,
                    originalGroupName: data.groupName,
                    groupHasPassword: data.groupHasPassword,
                    originalGroupHasPassword: data.groupHasPassword,
                    groupHasAdminPassword: data.groupHasAdminPassword,
                    originalGroupHasAdminPassword: data.groupHasAdminPassword,
                    groupContactData: data.contactData == null ? "" : data.contactData,
                    originalGroupContactData: data.contactData == null ? "" : data.contactData,
                    groupHourTypes: data.hourTypes == null ? [] : data.hourTypes,
                    originalGroupHourTypes: data.hourTypes == null ? [] : data.hourTypes,
                    groupAllowedHourTypes: data.allowedHourTypes == null ? [] : data.allowedHourTypes,
                    originalGroupAllowedHourTypes: data.allowedHourTypes == null ? [] : data.allowedHourTypes,
                    groupEmail: data.groupContactEmail == null ? "" : data.groupContactEmail,
                    originalGroupEmail: data.groupContactEmail == null ? "" : data.groupContactEmail,
                    groupYoutubeLink: data.youtubeLink == null ? "" : data.youtubeLink,
                    originalGroupYoutubeLink: data.youtubeLink == null ? "" : data.youtubeLink,
                    groupLocation: data.location == null ? "" : data.location,
                    originalGroupLocation: data.location == null ? "" : data.location
                });
            } else {
                that.setState({
                    groupName: newGroupName,
                    originalGroupName: "",
                    groupHasPassword: false,
                    originalGroupHasPassword: false,
                    groupHasAdminPassword: false,
                    originalGroupHasAdminPassword: false,
                    groupContactData: C.CONTACT_DATA_NONE,
                    originalGroupContactData: C.CONTACT_DATA_NONE,
                    groupHourTypes: [],
                    originalGroupHourTypes: [],
                    groupAllowedHourTypes: [],
                    originalGroupAllowedHourTypes: [],
                    groupEmail: "",
                    originalGroupEmail: "",
                    groupYoutubeLink: "",
                    originalGroupYoutubeLink: "",
                    groupLocation: "",
                    originalGroupLocation: "",
                });
            }
        })
    };
    updateGroup = (attribute, value) => () => {
        this.props.app.serverCommunication.serverUpdateGroup(this.state.groupName, attribute, this.state[value], () => this.groupEditNameChanged(this.state.groupName));
    };
    updateGroupStringify = (attribute, value) => () => {
        this.props.app.serverCommunication.serverUpdateGroup(this.state.groupName, attribute, JSON.stringify(this.state[value]), () => this.groupEditNameChanged(this.state.groupName));
    };
    changeColorPrint = (color) => {
        this.state.print.hourTypes.find((hourType) => {
            return hourType.hourType === this.state.printHourTypeIndex
        }, this).color = color;
        Utils.setPrintHourColor(this.state.printHourTypeIndex, color);
        this.setState({print: this.state.print});
        this.props.app.setState({print: this.state.print});
    };
    changeValueHourTypes = (hourTypeNames) => {
        let tempHourTypes = [];
        for (let hourTypeNameNumber in hourTypeNames) {
            let hourTypeID = C.hourTypeNameToIdMapping[hourTypeNames[hourTypeNameNumber]];
            let color = null;
            for (let oldHtN in this.state.originalGroupHourTypes) {
                if (oldHtN.hourType == hourTypeID) color = oldHtN.color;
            }
            if (color == null) color = C.hourTypeIdToDefaultColorMapping[hourTypeID];
            tempHourTypes.push({hourType: hourTypeID, color: color});
        }
        this.setState({groupHourTypes: tempHourTypes});
    };
    changeValueAllowedHourTypes = (hourTypeNames) => {
        let tempHourTypes = [];
        for (let hourTypeNameNumber in hourTypeNames) {
            let hourTypeID = C.hourTypeNameToIdMapping[hourTypeNames[hourTypeNameNumber]];
            tempHourTypes.push(hourTypeID);
        }
        this.setState({groupAllowedHourTypes: tempHourTypes});
    };

    renderUserLogout() {
        return Helper.getHourPanelViewActive() && !this.props.autoLogin ?
            <ListItem button onClick={this.logoutUser}>
                <ListItemIcon><LockOpen/></ListItemIcon>
                <ListItemText primary="Abmelden"/>
            </ListItem>
            : null;
    }

    renderContact() {
        return Helper.getHourPanelViewActive() && this.props.groupData != null && this.props.groupData.groupContactEmail != null
            && this.props.groupData.groupContactEmail != "" ?
            <ListItem>
                <ListItemText primary={this.props.groupData.groupContactEmail}
                              secondary={"Bei Fragen oder Stunde falsch eingetragen"}/>
            </ListItem>
            : null;
    }

    renderHourTypes() {
        const {classes} = this.props;
        if (Helper.getHourPanelViewActive() && this.props.groupData != null && this.props.groupData.hourTypes != null) {
            return [<ListItem key={1} button onClick={this.toggleValue('hourTypesOpen')}>
                <ListItemIcon><ColorLens/></ListItemIcon>
                <ListItemText inset primary="Stundentypen Legende"/>
                {this.state.hourTypesOpen ? <ExpandLess/> : <ExpandMore/>}
            </ListItem>,
                this.state.hourTypesOpen ? this.props.groupData.hourTypes.map((hourType) => {
                    return <ListItem className={classes.nested} key={"h" + hourType.hourType}
                                     style={{backgroundColor: hourType.color}}>
                        <ListItemText primary={C.hourTypeIdToNameMapping[hourType.hourType]}/>
                        {this.isAdmin() ? <ListItemSecondaryAction>
                            <IconButton color="secondary" aria-label="edit"
                                        onClick={this.changeColorDialog(hourType.hourType, hourType.color)}>
                                <ModeEdit/>
                            </IconButton>
                        </ListItemSecondaryAction> : null}
                    </ListItem>
                }) : null,
                <Popover key={2} open={this.state.hourTypeEditOpen}
                         anchorEl={this.state.hourTypeEditAnchor}
                         onClose={this.changeValueFixed('hourTypeEditOpen', false)}>
                    <ColorPicker color={this.state.hourTypeEditColor} onChange={this.changeColor}
                                 onClose={this.changeValueFixed('hourTypeEditOpen', false)}/>
                </Popover>]

        } else return null;
    }

    renderAdminLoginLogout() {
        const {classes} = this.props;
        return this.isAdmin() ?
            <ListItem button onClick={this.logoutAdmin}>
                <ListItemIcon><Settings/></ListItemIcon>
                <ListItemText primary="Admin Abmelden"/>
            </ListItem>
            :
            [<ListItem key={1} button onClick={this.toggleValue('adminLoginOpen')}>
                <ListItemIcon><Settings/></ListItemIcon>
                <ListItemText inset primary="Administrator Login"/>
                {this.state.adminLoginOpen ? <ExpandLess/> : <ExpandMore/>}
            </ListItem>,
                <Collapse key={2} component="li" in={this.state.adminLoginOpen} unmountOnExit>
                    <List disablePadding>
                        <ListItem className={classes.nested}>
                            <IntegrationAutosuggest placeholder="Admin login" value={this.state.adminLoginName}
                                                    suggestions={this.props.groupNames}
                                                    valueCallback={this.changeValue('adminLoginName')}/>
                        </ListItem>
                        <ListItem className={classes.nested}>
                            <Password valueCallback={this.changeValue('adminLoginPassword')} onEnter={this.loginAdmin} error={this.state.adminLoginFailed}/>
                        </ListItem>
                        <ListItem divider className={classes.nested}>
                            <Button variant="raised" style={{width: "100%"}} color="secondary"
                                    onClick={this.loginAdmin}>Anmelden</Button>
                        </ListItem>
                    </List>
                </Collapse>]
    }

    renderGroupEdit() {
        const {classes} = this.props;
        const groupAlreadyExisting = this.props.groupNames.indexOf(this.state.groupName) >= 0;
        return this.isAdmin() ? [
            <ListItem key={1} button onClick={this.toggleValue('groupEditOpen')}>
                <ListItemIcon><Group/></ListItemIcon>
                <ListItemText inset primary="Gruppe editieren"/>
                {this.state.groupEditOpen ? <ExpandLess/> : <ExpandMore/>}
            </ListItem>,
            <Collapse key={2} component="li" in={this.state.groupEditOpen} transitionDuration="auto" unmountOnExit>
                <List disablePadding>
                    {this.isSuperAdmin() ? <ListItem className={classes.nested}>
                        <IntegrationAutosuggest placeholder="Group Name" value={this.state.groupName}
                                                suggestions={this.props.groupNames}
                                                valueCallback={this.groupEditNameChanged}/>
                    </ListItem> : <ListItem className={classes.nested}><ListItemText primary={this.state.groupName}/></ListItem>}
                    <ListItem className={classes.nested}>
                        <Password label="Gruppen login password"
                                  onEnter={this.updateGroup('password', 'groupLoginPassword')}
                                  placeholder={this.state.originalGroupHasPassword ? "**********" : "neues Passwort"}
                                  valueCallback={this.changeValue('groupLoginPassword')}/>
                        {groupAlreadyExisting ? <ListItemSecondaryAction className={classes.updateGroupButton}>
                            <IconButton color="secondary" aria-label="updateGroupLoginPassword"
                                        onClick={this.updateGroup('password', 'groupLoginPassword')}><CloudUpload/></IconButton>
                        </ListItemSecondaryAction> : null}
                    </ListItem>
                    {this.isSuperAdmin() ? <ListItem className={classes.nested}>
                        <Password label="Gruppen admin password"
                                  onEnter={this.updateGroup('adminPassword', 'groupAdminPassword')}
                                  placeholder={this.state.originalGroupHasAdminPassword ? "**********" : "neues Passwort"}
                                  valueCallback={this.changeValue('groupAdminPassword')}/>
                        {groupAlreadyExisting ? <ListItemSecondaryAction className={classes.updateGroupButton}>
                            <IconButton color="secondary" aria-label="updateGroupAdminPassword"
                                        onClick={this.updateGroup('adminPassword', 'groupAdminPassword')}><CloudUpload/></IconButton>
                        </ListItemSecondaryAction> : null}
                    </ListItem> : null}
                    <ListItem className={classes.nested}>
                        <TextField fullWidth label="Kontakdaten der Gruppe"
                                   value={this.state.groupEmail}  onChange={this.changeValueByEvent('groupEmail')}/>
                        {groupAlreadyExisting && this.state.groupEmail != this.state.originalGroupEmail ?
                            <ListItemSecondaryAction className={classes.updateGroupButton}>
                                <IconButton color="secondary" aria-label="updateGroupEmail"
                                            onClick={this.updateGroup('email', 'groupEmail')}><CloudUpload/></IconButton>
                            </ListItemSecondaryAction> : null}
                    </ListItem>
                    <ListItem className={classes.nested}>
                        <form autoComplete="off" style={{width: "100%"}}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="groupContactData">Kontakttyp der Eintragenden</InputLabel>
                                <Select fullWidth
                                        value={this.state.groupContactData}
                                        onChange={this.changeValueByEvent('groupContactData')}
                                        input={<Input id="groupContactData" value=""/>}>
                                    <MenuItem value={C.CONTACT_DATA_NONE}>Nichts</MenuItem>;
                                    <MenuItem value={C.CONTACT_DATA_CELLPHONE}>Handynummer</MenuItem>;
                                    <MenuItem value={C.CONTACT_DATA_EMAIL}>Email</MenuItem>;
                                </Select>
                            </FormControl>
                        </form>
                        {groupAlreadyExisting && this.state.groupContactData != this.state.originalGroupContactData ?
                            <ListItemSecondaryAction className={classes.updateGroupButton}>
                                <IconButton color="secondary" aria-label="updateGroupContactData"
                                            onClick={this.updateGroup('contactData', 'groupContactData')}><CloudUpload/></IconButton>
                            </ListItemSecondaryAction> : null}
                    </ListItem>
                    <ListItem className={classes.nested}>
                        <MultipleSelect fullWidth onChange={this.changeValueHourTypes}
                                        values={C.hourTypeIdToNameMapping} label="Stundentypen Legende"
                                        selected={this.state.groupHourTypes.map(t => C.hourTypeIdToNameMapping[t.hourType])}/>
                        {groupAlreadyExisting && JSON.stringify(this.state.groupHourTypes) != JSON.stringify(this.state.originalGroupHourTypes) ?
                            <ListItemSecondaryAction className={classes.updateGroupButton}>
                                <IconButton color="secondary" aria-label="updateGroupHourTypes"
                                            onClick={this.updateGroupStringify('hourTypes', 'groupHourTypes')}><CloudUpload/></IconButton>
                            </ListItemSecondaryAction> : null}
                    </ListItem>
                    <ListItem className={classes.nested}>
                        <MultipleSelect fullWidth onChange={this.changeValueAllowedHourTypes}
                                        values={this.state.groupHourTypes.map(t => C.hourTypeIdToNameMapping[t.hourType])} label="Stundentypen eintragbar"
                                        selected={this.state.groupAllowedHourTypes.map(t => C.hourTypeIdToNameMapping[t])}/>
                        {groupAlreadyExisting && JSON.stringify(this.state.groupAllowedHourTypes) != JSON.stringify(this.state.originalGroupAllowedHourTypes) ?
                            <ListItemSecondaryAction className={classes.updateGroupButton}>
                                <IconButton color="secondary" aria-label="updateGroupAllowedHourTypes"
                                            onClick={this.updateGroupStringify('allowedHourTypes', 'groupAllowedHourTypes')}><CloudUpload/></IconButton>
                            </ListItemSecondaryAction> : null}
                    </ListItem>
                    <ListItem className={classes.nested}>
                        <TextField fullWidth label="Youtube Link"
                                   value={this.state.groupYoutubeLink}
                                   onChange={this.changeValueByEvent('groupYoutubeLink')}/>
                        {groupAlreadyExisting && this.state.groupYoutubeLink != this.state.originalGroupYoutubeLink ?
                            <ListItemSecondaryAction className={classes.updateGroupButton}>
                                <IconButton color="secondary" aria-label="updateGroupYoutubeLink"
                                            onClick={this.updateGroup('youtube', 'groupYoutubeLink')}><CloudUpload/></IconButton>
                            </ListItemSecondaryAction> : null}
                    </ListItem>
                    <ListItem className={classes.nested}>
                        <TextField fullWidth label="Location"
                                   value={this.state.groupLocation}
                                   onChange={this.changeValueByEvent('groupLocation')}/>
                        {groupAlreadyExisting && this.state.groupLocation != this.state.originalGroupLocation ?
                            <ListItemSecondaryAction className={classes.updateGroupButton}>
                                <IconButton color="secondary" aria-label="updateGroupLocation"
                                            onClick={this.updateGroup('location', 'groupLocation')}><CloudUpload/></IconButton>
                            </ListItemSecondaryAction> : null}
                    </ListItem>
                    {this.isSuperAdmin() ? <ListItem divider className={classes.nested} button
                                                     onClick={groupAlreadyExisting ? this.deleteGroup : this.addGroup}>
                        {groupAlreadyExisting ? <ListItemIcon><RemoveCircle/></ListItemIcon> :
                            <ListItemIcon><AddCircle/></ListItemIcon>}
                        <ListItemText primary={groupAlreadyExisting ? "Gruppe löschen" : "Gruppe hinzufügen"}/>
                    </ListItem> : null}
                </List>
            </Collapse>] : null;
    }

    renderSuperAdminEdit() {
        const {classes} = this.props;
        const superAdminNames = this.props.superAdmins != null ? this.props.superAdmins : [];
        return this.isSuperAdmin() ? [
            <ListItem key={1} button onClick={this.toggleValue('superAdminOpen')}>
                <ListItemIcon><Settings/></ListItemIcon>
                <ListItemText inset primary="Superadmin"/>
                {this.state.superAdminOpen ? <ExpandLess/> : <ExpandMore/>}
            </ListItem>,
            <Collapse key={2} component="li" in={this.state.superAdminOpen} transitionDuration="auto"
                      unmountOnExit>
                <List disablePadding fullWidth>
                    <ListItem className={classes.nested}>
                        <IntegrationAutosuggest placeholder="SuperAdmin name" value={this.state.superAdminEditName}
                                                suggestions={superAdminNames}
                                                valueCallback={this.changeValue('superAdminEditName')}/>
                    </ListItem>
                    <ListItem className={classes.nested} fullWidth>
                        <Password valueCallback={this.changeValue('superAdminPassword')} onEnter={this.editSuperAdmin}
                                  fullWidth/>
                    </ListItem>
                    <ListItem divider className={classes.nested}>
                        <Button variant="raised" style={{width: "100%"}} color="secondary"
                                onClick={this.editSuperAdmin}>Ändern oder Hinzufügen</Button>
                    </ListItem>
                </List>
            </Collapse>] : null;
    }

    renderPrint() {
        const {classes} = this.props;
        return Helper.getHourPanelViewActive() ? [
                <ListItem key={1} button onClick={this.toggleValue('printOpen')}>
                    <ListItemIcon><Print/></ListItemIcon>
                    <ListItemText primary="Ausdrucken"/>
                    {this.state.printOpen ? <ExpandLess/> : <ExpandMore/>}
                </ListItem>,
                <Collapse key={2} component="li" in={this.state.printOpen} transitionDuration="auto" unmountOnExit>
                    <ListItem className={classes.nested} fullWidth>
                        <div><DatePicker
                            leftArrowIcon={<KeyboardArrowLeft/>} rightArrowIcon={<KeyboardArrowRight/>}
                            eventIcon={<Event/>} dateRangeIcon={<DateRange/>} fullWidth
                            placeholder="Von" value={this.state.print.from} ampm={false}
                            onChange={this.handlePrintChanged('from')} helperText={"Von"}
                            animateYearScrolling={false}
                        /></div>
                    </ListItem>
                    <ListItem className={classes.nested} fullWidth>
                        <div><DatePicker
                            leftArrowIcon={<KeyboardArrowLeft/>} rightArrowIcon={<KeyboardArrowRight/>}
                            timeIcon={<Event/>} dateRangeIcon={<DateRange/>} fullWidth
                            placeholder="bis" value={this.state.print.to} ampm={false}
                            onChange={this.handlePrintChanged('to')} helperText={"Bis"}
                            animateYearScrolling={false}
                        /></div>
                    </ListItem>
                    {this.getPrintHourTypes().map((hourType) => {
                        return <ListItem className={classes.nested} key={"h" + hourType.hourType}
                                         style={{backgroundColor: hourType.color}}>
                            <ListItemText primary={C.hourTypeIdToNameMapping[hourType.hourType]}/>
                            <ListItemSecondaryAction>
                                <IconButton color="secondary" aria-label="edit"
                                            onClick={this.changeColorDialogPrint(hourType.hourType, hourType.color)}>
                                    <ModeEdit/>
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    })}
                    <Popover open={this.state.printHourTypeEditOpen}
                             anchorEl={this.state.printHourTypeEditAnchor}
                             onClose={this.changeValueFixed('printHourTypeEditOpen', false)}>
                        <ColorPicker color={this.state.printHourTypeEditColor} onChange={this.changeColorPrint}
                                     onClose={this.changeValueFixed('printHourTypeEditOpen', false)}/>
                    </Popover>
                    <ListItem divider className={classes.nested}>
                        <ListItemText primary="Druckermodus"/>
                        <ListItemSecondaryAction>
                            <Switch
                                onChange={this.handlePrintChangedFixed('enabled', !this.state.print.enabled)}
                                checked={this.state.print.enabled}
                            />
                        </ListItemSecondaryAction>
                    </ListItem>
                </Collapse>]
            : null;
    }

    getPrintHourTypes() {
        if (this.state.print.hourTypes != null) return this.state.print.hourTypes;
        if (this.props.groupData.hourTypes == null) return [];
        this.state.print.hourTypes = JSON.parse(JSON.stringify(this.props.groupData.hourTypes));
        for (let hour in this.state.print.hourTypes) {
            const color = Utils.getPrintHourColor();
            if (color != null) hour.color = color;
        }
        return this.state.print.hourTypes;
    }

}

OptionsDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OptionsDrawer);
